export default __webpack_public_path__ + "static/media/flagSpecial1.bb1f228b.svg";